import React from 'react';
import { connect } from 'react-redux';
import RefreshIndicator from 'material-ui/RefreshIndicator';

const styles = {
  container: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '48px 0',
  },
  refresh: {
    display: 'inline-block',
    position: 'relative',
  }
};

const Loading = (props) => {
  let left = 10 | props.left;

  return (
    <div style={styles.container}>
      <RefreshIndicator
        size={60}
        left={left}
        top={0}
        status="loading"
        style={styles.refresh}
      />
    </div>
  )
};

const mapStateToProps = state => ({ sidebarOpen: state.admin.ui.sidebarOpen });

const enhance = connect(mapStateToProps, null)(Loading);

export default enhance;



// WEBPACK FOOTER //
// ./src/components/Loading.js